// config.ts

export const AppConfig = {
    urlRoot: 'https://www.antiguoshop.ar/admin',
    parametro2: 'valor2'
  };